import request from '../api/request'
import axios from "axios";
import businessHelper from "../helpers/BusinessHelper";
import dateHelpers from "../helpers/DateHelper";

function attendanceStats(type) {
    return request({
        url: `yclasses/attendance_data.json?type=${type}`,
        method: 'GET',
    });
}

function ticketSales() {
    return request({
        url: `users/ticket_sales.json`,
        method: 'GET',
    });
}

function businessStats() {
    return request({
        url: `users/business_stats.json`,
        method: 'GET',
    });
}

function periodData(dateStart, dateEnd, allLocales = false) {
    if (allLocales) {
        return request({
            url: `users/period_data.json?date_start=${dateStart}&date_end=${dateEnd}&all_locales=true`,
            method: 'GET',
        });
    }
    else {
        return request({
            url: `users/period_data.json?date_start=${dateStart}&date_end=${dateEnd}`,
            method: 'GET',
        });
    }
}

function ticketReport(period) {
    return request({
        url: `/users/-1/ticket_report.json?date_start=${period.start}&date_end=${period.end}`,
        method: 'GET',
    });
}

function incomes(period) {
    return request({
        url: `incomes.json?start=${period.start}&end=${period.end}`,
        method: 'GET',
    });
}

function ticketsAndIncomes(period) {
    return axios.all([ticketReport(period), incomes(period)])
}

function incomesExpenses(period) {
    return request({
        url: `incomes/inc_exp_data.json?start=${period.start}&end=${period.end}`,
        method: 'GET',
    });
}

function postIncome(data, saveInvoice) {
    return request({
        url: `incomes.json?save_invoice=${saveInvoice}`,
        method: 'POST',
        data: data
    });
}

function updateIncome(data, saveInvoice) {
    return request({
        url: `incomes/${data.id}.json?save_invoice=${saveInvoice}`,
        method: 'PUT',
        data: data
    });
}

function deleteIncome(id) {
    return request({
        url: `incomes/${id}.json`,
        method: 'DELETE',
    });
}

function postExpense(data, saveInvoice) {
    return request({
        url: `expenses.json?save_invoice=${saveInvoice}`,
        method: 'POST',
        data: data
    });
}

function updateExpense(data, saveInvoice) {
    return request({
        url: `expenses/${data.id}.json?save_invoice=${saveInvoice}`,
        method: 'PUT',
        data: data
    });
}

function deleteExpense(id) {
    return request({
        url: `expenses/${id}.json`,
        method: 'DELETE',
    });
}

function invoices(period, filters, export_only = false) {
    let types = [];
    if (filters.tickets == true) {types.push('t')}
    if (filters.incomes == true) {types.push('i')}
    if (filters.expenses == true) {types.push('e')}
    if (filters.other == true) {types.push('o')}

    types = types.join(",")
    return request({
        url: `invoices_api/period_overview.json?start=${period.start}&end=${period.end}&search=${filters.search}&export_only=${export_only}&types=${types}`,
        method: 'GET',
    });
}

function invoice(id) {
    return request({
        url: `invoices_api/web_invoice.json?id=${id}`,
        method: 'GET',
    });
}

function deleteInvoice(id) {
    return request({
        url: `invoices_api/${id}.json`,
        method: 'DELETE',
    });
}

function sendInvoice(id) {
    return request({
        url: `invoices/send_pdf_to_client.json?user_id=${businessHelper.business().id}&invoice_id=${id}`,
        method: 'GET',
    });
}

function invoiceLink(id) {
    return request({
        url: `invoices_api/show_invoice.json?id=${id}`,
        method: 'GET',
    });
}

function exportIncomes(period) {
    return request({
        url: `users/export_incomes.json?date_start=${period.start}&date_end=${period.end}`,
        method: 'GET',
    });
}

function exportInvoices(period) {

    this.prepareRequestString = function (period) {
        const t = localStorage.invoice_filters_t
        const i = localStorage.invoice_filters_i
        const o = localStorage.invoice_filters_o
        const s = localStorage.invoice_filters_s

        if ((t === "true" && i === 'true' && o === 'true') || (t === "false" && i === 'false' && o === 'false')) {
            return `invoices/send_pdfs.json?start=${period.start}&end=${period.end}&user_id=${businessHelper.business().id}&search=${s !== "null" ? s : ""}`
        }
        else if (t === "true" && i === 'true') {
            return `invoices/send_pdfs.json?start=${period.start}&end=${period.end}&user_id=${businessHelper.business().id}&search=${s !== "null" ? s : ""}&types=t,i`
        }
        else if (t === "true" && o === 'true') {
            return `invoices/send_pdfs.json?start=${period.start}&end=${period.end}&user_id=${businessHelper.business().id}&search=${s !== "null" ? s : ""}&types=t,o`
        }
        else if (i === "true" && o === 'true') {
            return `invoices/send_pdfs.json?start=${period.start}&end=${period.end}&user_id=${businessHelper.business().id}&search=${s !== "null" ? s : ""}&types=o,i`
        }
        else if (t === "true") {
            return `invoices/send_pdfs.json?start=${period.start}&end=${period.end}&user_id=${businessHelper.business().id}&search=${s !== "null" ? s : ""}&types=t`
        }
        else if (i === "true") {
            return `invoices/send_pdfs.json?start=${period.start}&end=${period.end}&user_id=${businessHelper.business().id}&search=${s !== "null" ? s : ""}&types=i`
        }
        else if (o === "true") {
            return `invoices/send_pdfs.json?start=${period.start}&end=${period.end}&user_id=${businessHelper.business().id}&search=${s !== "null" ? s : ""}&types=o`
        }
    }

    return request({
        url: this.prepareRequestString(period),
        method: 'GET',
    });
}

function exportTickets(period, by_expiration = false, filters) {
    return request({
        url: `users/export_tickets.json?date_start=${period.start}&date_end=${period.end}&by_expiration=${by_expiration}&ticket_types=${filters ? filters.ticketTypes : null}&payment_methods=${filters ? filters.paymentMethods : null}`,
        method: 'POST',
    });
}

function exportExpiringTickets(period) {
    return request({
        url: `users/export_tickets.json?date_start=${period.start}&date_end=${period.end}&exp=true`,
        method: 'POST',
    });
}

// ADMIN

function admin_activeUsers() {
    return request({
        url: `analytics/a_user_data/?elephant=eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0OCwiZXhwIjoxNTgwMDQxMDYxfQ.zgI6RNTBgzU56sLte6FL-Sh8lhuz98k9PurHSJAWbsg`,
        method: 'GET',
    });
}

function admin_all_businesses(today = false, exp_subscr = false) {
    return request({
        url: `analytics/a_all_business_data.json?elephant=eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0OCwiZXhwIjoxNTgwMDQxMDYxfQ.zgI6RNTBgzU56sLte6FL-Sh8lhuz98k9PurHSJAWbsg&today=${today}&exp_subscr=${exp_subscr}`,
        method: 'GET',
    });
}

function admin_all_businesses_new() {
    return request({
        url: `analytics/a_all_business.json?elephant=eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0OCwiZXhwIjoxNTgwMDQxMDYxfQ.zgI6RNTBgzU56sLte6FL-Sh8lhuz98k9PurHSJAWbsg`,
        method: 'GET',
    });
}

function hide_business(id) {
    return request({
        url: `businesses/hide?id=${id}`,
        method: 'POST',
    });
}

function unpublish(id) {
    return request({
        url: `businesses/unpublish?id=${id}`,
        method: 'POST',
    });
}

function make_client(id) {
    return request({
        url: `businesses/make_client?id=${id}`,
        method: 'POST',
    });
}

function send_web_news(id) {
    return request({
        url: `businesses/send_web_news?id=${id}`,
        method: 'POST',
    });
}

function send_news_082020(id) {
    return request({
        url: `businesses/send_news_082020?id=${id}`,
        method: 'POST',
    });
}

function endTrial(id) {
    return request({
        url: `businesses/end_trial?id=${id}`,
        method: 'POST',
    });
}

function startTrial(id) {
    return request({
        url: `businesses/start_trial?id=${id}`,
        method: 'POST',
    });
}

function sendTrialExpiresEmail(id) {
    return request({
        url: `businesses/send_trial_expires?id=${id}`,
        method: 'POST',
    });
}

function admin_sm(id) {
    return request({
        url: `analytics/a_sm/?id=${id}`,
        method: 'POST',
    });
}

function admin_new_users(type = "week") {
    return request({
        url: `analytics/a_new_users?type=${type}`,
        method: 'GET',
    });
}

function admin_total_users(type = "week") {
    return request({
        url: `analytics/a_total_users?type=${type}`,
        method: 'GET',
    });
}

function admin_events(type = "week") {
    return request({
        url: `analytics/a_events?type=${type}`,
        method: 'GET',
    });
}

function admin_daily_visits(type = "week") {
    return request({
        url: `analytics/daily_visits?type=${type}`,
        method: 'GET',
    });
}

function admin_activity(type = "week") {
    return request({
        url: `analytics/a_activity?type=${type}`,
        method: 'GET',
    });
}

function business_activity(type = "week") {
    return request({
        url: `analytics/business_activity?type=${type}`,
        method: 'GET',
    });
}

function tickets_by_type(type = "week") {
    return request({
        url: `analytics/tickets_by_type?type=${type}`,
        method: 'GET',
    });
}

function makeData(name, params) {
    let props = {source: "web"}
    if (params !== null) {
        for (const k in params) props[k] = params[k]
    }
    return [{name: name, properties: props, time: dateHelpers.databaseDateTime(new Date())}]
}

function analytics(type) {
    return axios.all([admin_new_users(type), admin_total_users(type), admin_events(type), admin_activity(type), admin_daily_visits(type)])
}

function business_analytics(type) {
    return axios.all([business_activity(type), tickets_by_type(type)])
}

function ahoy(name, params = null) {
    return request({
        url: `users/ahoy_events`,
        method: 'POST',
        data: {events: makeData(name, params)}
    });
}

function admin_all_events(name, last = 100, userId = -1) {
    return request({
        url: `analytics/events.json?name=${name}&last=${last}&uid=${userId}`,
        method: 'GET',
    });
}

function admin_subscriptions() {
    return request({
        url: `analytics/subs.json?elephant=eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0OCwiZXhwIjoxNTgwMDQxMDYxfQ.zgI6RNTBgzU56sLte6FL-Sh8lhuz98k9PurHSJAWbsg`,
        method: 'GET',
    });
}

function updateCashier(params) {
    return request({
        url: `cashiers/update.json`,
        method: 'PUT',
        params: params
    });
}

function deleteCashier(params) {
    return request({
        url: `cashiers/delete.json`,
        method: 'PUT',
        params: params
    });
}

function closeCashier(params) {
    return request({
        url: `cashiers/close.json`,
        method: 'POST',
        params: params
    });
}

function getCashiers(params) {
    return request({
        url: `cashiers.json`,
        method: 'GET',
        params: params
    });
}

function exportCashierData(params) {
    return request({
        url: `cashiers/export.json`,
        method: 'POST',
        params: params
    });
}

function incomesExpensesForDay(date) {
    return request({
        url: `cashiers/expenses_and_incomes.json`,
        method: 'GET',
        params: {date: date}
    });
}
function getFeedbacks() {
    return request({
        url: `businesses/feedbacks.json`,
        method: 'GET',
    });
}

function newClients(n = 100) {
    return request({
        url: `analytics/new_clients.json?elephant=eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0OCwiZXhwIjoxNTgwMDQxMDYxfQ.zgI6RNTBgzU56sLte6FL-Sh8lhuz98k9PurHSJAWbsg`,
        method: 'GET',
        params: {count: n}
    });
}

function reportSettings() {
    return request({
        url: `businesses/report_settings.json`,
        method: 'GET',
    });
}

function toggleDailyReports(userId) {
    return request({
        url: `unsubscribe/report`,
        method: 'GET',
        params: {topic: "DAILY_REPORT", user_id: userId}
    });
}

function sendDailyReport() {
    return request({
        url: `businesses/send_daily_report.json`,
        method: 'POST',
    });
}

function getCoordinates() {
    return request({
        url: `businesses/shop_coordinates.json?elephant=eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0OCwiZXhwIjoxNTgwMDQxMDYxfQ.zgI6RNTBgzU56sLte6FL-Sh8lhuz98k9PurHSJAWbsg`,
        method: 'POST',
    });
}

function getTeacherSessions(businessId, date) {
    return request({
        url: `businesses/${businessId}/sessions.json?date=${date}`,
        method: 'GET',
    });
}

function deleteSession(sessionId) {
    return request({
        url: `teacher_sessions/${sessionId}/remove.json`,
        method: 'POST',
    });
}

function exportTeacherSessions(date) {
    return request({
        url: `teacher_sessions/export.json`,
        method: 'POST',
        params: {date: date}
    });
}

function attendanceReport(period) {
    return request({
        url: `yclasses.json?date1=${period.start}&date2=${period.end}&light=t&export=true`,
        method: 'GET'
    });
}

function studentWithUnpaidClasses(range) {
    return request({
        url: `businesses/students_with_unpaid_classes.json?range=${range || "week"}`,
        method: 'GET'
    });
}

const reportApiService = {
    attendanceStats, ticketSales, businessStats, periodData, ticketsAndIncomes, incomesExpenses,
    postExpense, postIncome, updateExpense, updateIncome, deleteExpense, deleteIncome,
    invoices, deleteInvoice, sendInvoice, invoiceLink, exportIncomes, exportInvoices,
    exportTickets, exportExpiringTickets, business_activity, business_analytics,
    admin_activeUsers, admin_sm, admin_new_users, admin_total_users, admin_events, admin_activity, analytics,
    ahoy, admin_all_events, invoice, admin_subscriptions,
    admin_all_businesses, hide_business, unpublish, make_client, send_web_news, sendTrialExpiresEmail, endTrial, startTrial,
    updateCashier, deleteCashier, closeCashier, getCashiers, exportCashierData, incomesExpensesForDay,
    send_news_082020, newClients, getFeedbacks, reportSettings, toggleDailyReports, sendDailyReport,
    getCoordinates, getTeacherSessions, deleteSession, exportTeacherSessions, attendanceReport, studentWithUnpaidClasses,
    admin_all_businesses_new
};

export default reportApiService;